// The speaker app's core extension point.
//
// A "module" is a self-contained feature: it declares an ID, a slot in the DOM
// to mount into, optional MQTT topic subscriptions, and a `mount(ctx)` function
// that the app calls during boot. To add a new feature (e.g. annotation overlay,
// audience-poll widget), drop a file in modules/ and `register` it in app.js.
//
// Context passed to each module:
//   ctx.session    — session id
//   ctx.config     — loaded /config.json
//   ctx.iot        — IotClient instance (publish + subscribe)
//   ctx.bus        — EventBus (in-app pub/sub mirroring MQTT)
//   ctx.deck       — deck bridge (iframe controller)
//   ctx.slot       — the DOM element to render into (matched by data-slot)
//   ctx.shell      — root <main> element
//   ctx.setStatus  — helper to set the connection status indicator

export class ModuleRegistry {
  constructor() { this.modules = []; }

  register(mod) {
    if (!mod.id || typeof mod.mount !== 'function') {
      throw new Error('Module must have id and mount()');
    }
    this.modules.push(mod);
  }

  async mountAll(ctx) {
    for (const mod of this.modules) {
      const slot = mod.slot ? document.querySelector(`[data-slot="${mod.slot}"]`) : null;
      if (mod.slot && !slot) { console.warn(`[registry] no slot "${mod.slot}" for module ${mod.id}`); continue; }
      if (mod.subscribes) for (const t of mod.subscribes(ctx)) ctx.iot.subscribe(t);
      try {
        await mod.mount({ ...ctx, slot });
      } catch (e) {
        console.error(`[registry] mount ${mod.id} failed`, e);
      }
    }
  }
}
